import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useRouter } from 'next/router';
import { shouldExcludeDownloadAppBanner } from '../utils';
import { usePageSettings } from '@bridebook/web/lib/page-settings-context';
import { useSelector } from '@bridebook/web/lib/utils';
import { getScreenType } from '@bridebook/web/lib/app/selectors';

export const useShouldHideAppBanner = () => {
  const { asPath } = useRouter();
  const market = useMarket();
  const { isSearchPage } = usePageSettings();
  const { isDesktop } = useSelector(getScreenType);

  const hideForSearchPage = isSearchPage && !isDesktop;

  return hideForSearchPage || shouldExcludeDownloadAppBanner(asPath, market);
};
